import React, { Component } from "react";
import styles from "./PricingWrapper.module.scss";
import { withTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import HasPermissionTo from "../../../common/HasPermissionTo";
import SubNavDropdown from "../../../shared/subnav/SubNavDropdown";
import PendingActionClient from "../../../shared/clients/PendingActionClient";
import { ACCESSORIES_VERSION } from "../../../common/Constants";
import Grid from "@material-ui/core/Grid";
import ChevronRightIcon from "@material-ui/icons/ChevronRight";
import StatusOverview from "./statusOverview/StatusOverview";
import VehicleCatalogClient from "../../../shared/clients/VehicleCatalogClient";

const DisplayPricingType = (props) => {
  return (
    <Grid item md={3} xs={6}>
      <div className={styles.priceType}>
        <div>
          <div className={styles.priceTitle}>{props.header}</div>
          <div className={styles.pricingText}>
            {props.desc ? props.desc : "--"}
          </div>
          <Link
            className={styles.link}
            data-testid={props.name}
            to={props.link}
            name={props.name}
          >
            <div className={styles.pageBottom}>
              {props.goto}
              <ChevronRightIcon className={styles.rightChevron} />
            </div>
          </Link>
        </div>
      </div>
    </Grid>
  );
};

class PricingWrapper extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showAccessories: props.user.hasNscCompletedBasicPAs,
      renderApp: false,
      vehicles: [],
    };
  }

  componentDidMount() {
    this.showAccessories();
    this.props.user.permissions.rolePermissions.hasOwnProperty(
      "statusOverviewTable"
    ) && this.fetchVehicleStatuses();
  }

  showAccessories = () => {
    const market = this.props.user.market;
    if (
      !this.props.isNsc &&
      ACCESSORIES_VERSION[this.props.user.market] === 3
    ) {
      PendingActionClient.getHasNscCompletedPA(this.props.user, 3, market).then(
        (response) => {
          this.setState({ showAccessories: response });
        }
      );
    }
    this.setState({ renderApp: true });
  };

  fetchVehicleStatuses = () => {
    !this.props.isNsc &&
      VehicleCatalogClient.getStatusOverviewTable(this.props.user)
        .then((response) => {
          const vehicles = [];
          response &&
            response.forEach((vehicleLine) => {
              vehicleLine &&
                vehicles.push({
                  model: vehicleLine.model,
                  current: vehicleLine.currentYearStatus,
                  previous: vehicleLine.previousYearStatus,
                });
            });
          this.setState({ vehicles: vehicles, renderApp: true });
        })
        .catch(() => this.setState({ renderApp: true }));
  };

  render() {
    return (
      this.state.renderApp && (
        <div className="pageWrapper" id="PricingWrapper">
          <div className={`${styles.titleDiv} pagePadding`}>
            <div className="pageTitle">
              {this.props.t("PricingWrapper.title")}
            </div>
            <HasPermissionTo
              perform={["AllCMA:view"]}
              permissions={this.props.user.permissions.rolePermissions}
              condition={
                !this.props.restrictDropdown &&
                this.props.user.dealerGroup &&
                this.props.user.dealerGroup.length > 1
              }
              render={() => <SubNavDropdown {...this.props} />}
            />
          </div>
          <p className={`${styles.subHeader} pagePadding`}>
            {this.props.t("PricingWrapper.subTitle")}
          </p>

          <Grid container spacing={24} className={styles.pricing}>
            <HasPermissionTo
              perform={["pricingAdministration"]}
              permissions={this.props.user.permissions.rolePermissions}
              render={() => (
                <DisplayPricingType
                  header={this.props.t(
                    "PricingWrapper.priceEventAdministration"
                  )}
                  desc={this.props.t(
                    "PricingWrapper.priceEventAdministrationDesc"
                  )}
                  goto={this.props.t("PricingWrapper.gotoPage")}
                  link="/pricing/event"
                  name="event"
                />
              )}
            />
            <DisplayPricingType
              header={this.props.t("PricingWrapper.deposit")}
              desc={this.props.t("PricingWrapper.depositDesc")}
              goto={this.props.t("PricingWrapper.gotoPage")}
              link="/pricing/deposit"
              name="deposit"
            />
            <HasPermissionTo
              perform={["vehiclePricingTab"]}
              permissions={this.props.user.permissions.rolePermissions}
              condition={this.props.user.hasNscCompletedBasicPAs}
              render={() => (
                <DisplayPricingType
                  header={this.props.t("PricingWrapper.currentPricing")}
                  desc={this.props.t("PricingWrapper.currentPricingDesc")}
                  goto={this.props.t("PricingWrapper.gotoPage")}
                  link="/pricing/vehicles"
                  name="vehicles"
                />
              )}
            />
            <HasPermissionTo
              perform={["accessoriesPricingTab"]}
              permissions={this.props.user.permissions.rolePermissions}
              condition={this.state.showAccessories}
              render={() => (
                <DisplayPricingType
                  header={this.props.t("PricingWrapper.accessoriesPricing")}
                  desc={this.props.t("PricingWrapper.accessoriesPricingDesc")}
                  goto={this.props.t("PricingWrapper.gotoPage")}
                  link="/pricing/accessories"
                  name="accessories"
                />
              )}
            />
            <HasPermissionTo
              perform={["futurePricingTab"]}
              permissions={this.props.user.permissions.rolePermissions}
              condition={this.props.user.hasNscCompletedBasicPAs}
              render={() => (
                <DisplayPricingType
                  header={this.props.t("PricingWrapper.futurePricing")}
                  desc={this.props.t("PricingWrapper.futurePricingDesc")}
                  goto={this.props.t("PricingWrapper.gotoPage")}
                  link="/pricing/future"
                  name="future"
                />
              )}
            />
          </Grid>
          <HasPermissionTo
            perform={["statusOverviewTable"]}
            permissions={this.props.user.permissions.rolePermissions}
            condition={this.state.vehicles && this.state.vehicles.length > 0}
            render={() => (
              <StatusOverview {...this.props} vehicles={this.state.vehicles} />
            )}
          />
        </div>
      )
    );
  }
}

export default withTranslation("emp")(PricingWrapper);
